define([
	"dojo/_base/lang",
	"dojo/_base/declare",
	"csi/def/Action",
	"csi/def/ViewRef",
	"csi/heading/Ref",
	"csi/xml",
	"csi/xml/Query"
], function(lang,declare,Action,ViewRef,Ref,xml,Query) {

	return declare(Ref, {

		_getStoreAction: function(/*Context*/ctx, /*Heading*/h, /*Boolean*/bAll) {
			//summary: C8-2393: Final Inspection Inspector Assigmnents
			var inspectionSecGroupUrl = ctx.getNode().__Parent__;
			var viewRef;

			if (xml.isValidURL(inspectionSecGroupUrl)) {
				// FinalInspection under a Security Group, user should be part of the assigned team of the security group
				viewRef = lang.mixin(new ViewRef(), {
					m_id : "UserRoles",
					m_path : "Child:__Parent__/Child:Node Crew"
				});
			} else {
				// Stand-alone FinalInspection not under a security group: All global user with roles
				viewRef = lang.mixin(new ViewRef(), {
					m_id : "ActiveUsers",
					m_url : "centric://REFLECTION/INSTANCE/_CS_Data/null"
				});
			}

			// Users with the role "Inspection Administrator" or "Inspection Editor" or “Inspection Library Administrator” will be displayed
			var path = "Parent:__Members__/Child:__Parent__/Parent:SubGroups";
			var query = new Query();
			query.Or()
				.Node(xml.PROP_URL, xml.OP_EQUALS, "centric://REFLECTION/INSTANCE/Role/Inspection Administrator", path)
				.Node(xml.PROP_URL, xml.OP_EQUALS, "centric://REFLECTION/INSTANCE/Role/Inspection Planner", path)
				.Node(xml.PROP_URL, xml.OP_EQUALS, "centric://REFLECTION/INSTANCE/Role/Inspection Editor", path)
				.Node(xml.PROP_URL, xml.OP_EQUALS, "centric://REFLECTION/INSTANCE/Role/Inspection Library Administrator", path);

			return lang.mixin(new Action(), {
				m_fixedQuery: query,
				m_viewRef : viewRef
			});
		},

		getStore: function(/* Context */ctx, /* Heading */h, /* Any */value, /*Boolean*/bAll) {
			//summary: C8-2393: Final Inspection Inspector Assigmnents
			var store = this.inherited(arguments);

			if (store && !store.isLoaded()) {
				// add parameters to the request to switch between global user or contextual users to be returned
				var inspectionSecGroup = ctx.getParent();
				if (inspectionSecGroup) {
					// FinalInspection is under a Security Group, user should be part of the assigned team of the security group
					store.request.addParameter("Dep.CrewUserAssignment", inspectionSecGroup.Crew);
					store.request.addParameter("Dep.CrewIncludeGlobal", false);
				} else {
					// Stand-alone FinalInspection not under a security group: All global user with roles
					store.request.addParameter("Dep.CrewIncludeGlobal", true);
				}
			}

			return store;
		}

	});
});